<template>
  <div class="authWrapper new-login-wrapper recover-email-wrapper">
    <div class="container">
      <div class="row login-white-wrap whiteBG-wrap login-margin">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <div class="email-login-form" role="main" aria-labelledby="recover-email-title">
              <div class="left-login">
                <div class="rep-icon-login">
                  <img src="../../assets/images/member-login.svg" alt="Member login icon" />
                </div>
                <div></div>
              </div>
              <h4 class="login-title mb-3" id="recover-email-title">Email Recovered Successfully</h4>

              <div class="auth-form pt-1 pb-3">
                <div class="verification-detail p-0 text-center">

                  <div class="recovered-email-section" role="status" aria-live="polite"
                    :aria-label="'Recovered email: ' + email" :aria-describedby="'recover-email-desc'">

                    <div class="recovery-info mb-2">
                      <!-- success icon -->
                      <div class="verification-icon" role="img" aria-label="Success checkmark">
                        <img src="@/assets/images/ph-seal-check.svg" alt="Success verification icon"
                          class="img-fluid" />
                      </div>

                      <!-- recovered email info -->
                      <div class="recovered-email-info text-left">
                        <p class="recovered-label">Your recovered email address:</p>
                        <h2 class="recovered-email mb-2" :aria-label="'Email address: ' + email">
                          {{ email }}
                        </h2>
                      </div>
                    </div>
                    <!-- recovered email description -->
                    <p class="sub-head text-left mb-0" id="recover-email-desc">
                      We've successfully recovered your login email address. You can now proceed to log in.
                    </p>

                  </div>

                </div>
                <div class="action-btn flex-column gap-2">
                  <button type="button" class="submit-btn next-btn m-0" @click="loginLink"
                    aria-label="Go to login page">
                    Continue to Login
                  </button>

                  <div class="additional-actions">
                    <router-link :to="{ name: 'ForgotEmail' }" class="login-highlight"
                      aria-label="Recover another email">
                      Recover another email?
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding p-0">
          <LoginCarsoule />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Helper from "@/resource/Helper";
import LoginCarsoule from "../NewLogin/Logincarsoule.vue";

export default {
  name: "RecoverEmail",
  components: {
    LoginCarsoule,
  },
  data: () => {
    return {
      email: "",
    };
  },
  methods: {
    loginLink() {
      Helper.resetRegisterMemberAuth();
      this.$router.push({
        name: "Login",
        params: { tempEmail: this.email },
      });
    },
  },
  created() {
    this.email = this.$route.params.tempEmail;
    if (!this.email) {
      this.$router.push({
        name: "Login",
      });
    }
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style scoped>
@import "../../assets/css/verification.css";

.email-login-form {
  width: 100%;
  color: #111827;
}

.sub-head {
  color: #6B7280;
  font-size: 15px;
  line-height: 1.6;
}

.verification-detail {
  padding: 0;
}

.recovery-info {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.5rem;
}

.verification-icon {
  max-width: 3rem;
  margin: 0;
}

.verification-icon img {
  color: #37c643;
}

.verification-icon img {
  width: 100%;
}

.recovered-email-section {
  padding: 0 0 1.25rem 0;
  border-radius: 12px;
}

.recovered-label {
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6B7280;
  margin-bottom: 0rem;
}

.recovered-email {
  font-size: 18px;
  font-weight: 600;
  color: #00ccff;
  word-break: break-word;
  letter-spacing: 2px;
  line-height: 1.4;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.action-btn.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-2 {
  gap: 0.75rem;
}

.submit-btn {
  width: 100%;
  background: linear-gradient(90deg, #00CCFE 0%, #00AEEF 100%);
  border: none;
  color: #fff;
  padding: 14px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  transition: transform 0.2s ease, background 0.3s ease;
}

.submit-btn:hover {
  background: linear-gradient(90deg, #00AEEF 0%, #0088CC 100%);
  transform: translateY(-1px);
}

.submit-btn:focus-visible,
.login-highlight:focus-visible {
  outline: 2px solid #00CCFE;
  outline-offset: 2px;
}

.login-highlight {
  color: #0EA5E9;
  font-weight: 600;
  transition: color 0.2s ease;
}

.login-highlight:hover {
  color: #0284C7;
  text-decoration: none;
}

.additional-actions {
  width: 100%;
  text-align: center;
}
</style>